export default __webpack_public_path__ + "static/media/1.bbf8e881.jpg";